import * as React from 'react';
import styles from './table.module.scss';

const Table: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <table className={styles.table}>{children}</table>;
};

export { Table };
